<template>
    <div class="chart-block">
        <Chart
            v-if="hasData"
            type="bar"
            :data="chartData"
            :options="chartOptions"
            class="w-full"
        />
        <div v-else class="chart-empty">Sem dados</div>
    </div>
</template>

<script>
import SafeChart from '@/components/SafeChart.vue';

export default {
    name: 'VerticalBarQtdEtapas',
    components: { Chart: SafeChart },
    props: {
        rawData: { type: Object, default: () => ({}) },
        colorMap: { type: Object, required: true },
        activeIndex: { type: Number, default: -1 }
    },
    computed: {
        hasData() {
            return this.rawData?.labels?.length && this.rawData?.datasets?.length;
        },
        chartData() {
            if (!this.hasData) return {};
            const etapaColors = (this.rawData.labels || []).map(label => this.colorMap[label] || '#6b7280');
            const datasets = this.rawData.datasets.map((ds, dsIdx) => ({
                ...ds,
                backgroundColor: etapaColors,
                borderColor: etapaColors.map((c, i) => i === this.activeIndex ? c : 'transparent'),
                borderWidth: etapaColors.map((_, i) => i === this.activeIndex ? 2 : 0),
                borderDash: [4, 4],
                borderRadius: 4,
                barPercentage: 0.6,
                categoryPercentage: 0.8,
            }));
            return { ...this.rawData, datasets };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: 'rgba(20,20,20,0.95)',
                        titleColor: '#e6edf3',
                        bodyColor: '#8b949e',
                        cornerRadius: 6,
                        padding: 8,
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: { color: '#8b949e', font: { size: 10 }, maxRotation: 30 }
                    },
                    y: {
                        grid: { color: 'rgba(255,255,255,0.06)', drawBorder: false },
                        ticks: { color: '#8b949e', font: { size: 11 } }
                    }
                }
            };
        }
    }
}
</script>

<style scoped>
.chart-block { height: 240px; }
.chart-empty { display: flex; align-items: center; justify-content: center; height: 100%; color: #6b7280; }
</style>
